import { LOW_ENVIRONMENTS } from './constants';

export const openInNewTab = (url: string, params: Record<string, string>): void => {
  const queryParams = new URLSearchParams(params).toString();

  window.open(`${url}?${queryParams}`, '_blank');
};

export const roundToFractionDigits = (value: number, digits: number = 0) => value.toFixed(digits);

export const isLowEnv = (): boolean => {
  if (!window.env.ENVIRONMENT) {
    return false;
  }

  return LOW_ENVIRONMENTS.includes(window.env.ENVIRONMENT);
};